import React from 'react'

export default props => <svg
  width="13"
  height="13"
  viewBox="0 0 13 13"
  fill="none"
  {...props}
>
  <rect x="0.295455" y="0.295455" width="0.590909" height="2.95455" transform="translate(5.91016 5.91016)" stroke="#4F4F4F" strokeWidth="0.590909"/>
  <rect x="0.295455" y="0.295455" width="0.590909" height="0.590909" transform="translate(5.91016 3.54688)" stroke="#4F4F4F" strokeWidth="0.590909"/>
  <circle cx="6.5" cy="6.5" r="6" stroke="#4F4F4F"/>
</svg>



// WEBPACK FOOTER //
// ./src/modules/ControlWrapper/HelpIcon/HelpIconSvg.js